import { createTheme } from '@mui/material';

const devcenterTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      md: 768,
      lg: 1224,
    },
  },
  components: {
    MuiFormLabel: {
      styleOverrides: {
        asterisk: {
          color: 'red',
          '&$error': {
            color: 'red',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: '1rem',
          borderRadius: '0',
          boxShadow: 'none',
        },
      },
      variants: [
        {
          props: { variant: 'contained' },
          style: {
            justifyContent: 'space-between',
            '&:hover': {
              backgroundColor: 'transparent',
              boxShadow: 'none',
            },
          },
        },
        {
          props: { variant: 'outlined' },
          style: {
            justifyContent: 'space-between',
          },
        },
        {
          props: { variant: 'text' },
          style: {
            '&:hover': {
              textDecoration: 'underline',
              backgroundColor: 'transparent',
            },
          },
        },
      ],
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          fontSize: '1rem',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          fontWeight: '400',
          borderRadius: '0',
        },
      },
    },
  },
  palette: {
    primary: {
      light: '#757ce8',
      main: '#0a46ff',
      dark: '#002884',
      contrastText: '#fff',
    },
    secondary: {
      main: '#000',
    },
  },
  shadows: [
    'none',
    '0px 6px 16px rgba(0, 0, 0, 0.06)',
    '0px 8px 16px rgba(0, 0, 0, 0.12)',
  ],
  typography: {
    fontFamily: ['"Pretendard"', 'sans-serif'].join(','),
    fontWeight: 400,
    // fontWeightLight: 400,
    // fontWeightRegular: 600,
    // fontWeightBold: 700,
    h1: {
      fontWeight: 700,
      fontSize: '4rem',
    },
    h2: {
      fontWeight: 600,
      fontSize: '3rem',
    },
    h3: {
      fontWeight: 700,
      fontSize: '2rem',
    },
    h4: {
      fontWeight: 600,
      fontSize: '1.75rem',
    },
    h5: {
      fontWeight: 600,
      fontSize: '1.5rem',
    },
    h6: {
      fontWeight: 600,
      fontSize: '1.375rem',
    },
    subtitle1: {
      fontWeight: 600,
      fontSize: '1.125rem',
    },
    subtitle2: {
      fontWeight: 600,
    },
    body1: {
      color: '#424242',
    },
    body2: {
      fontSize: '0.9375rem',
    },
  },
});

export { devcenterTheme };
